import { Tabs } from 'antd';
import styled from 'styled-components';

import { NeutralColors } from '@/theme';

export const StyledTabs = styled(Tabs)`
  display: flex;
  flex-direction: column;
  flex: 1;

  .panorama-tabs-nav::before {
    border-bottom: 1px solid ${NeutralColors[20]};
  }

  .panorama-tabs-tab {
    padding: 8px 16px;
  }

  .panorama-tabs-tab:not(.panorama-tabs-tab-active) .panorama-tabs-tab-btn {
    color: ${NeutralColors[60]};
  }

  .panorama-tabs-tab-active .panorama-tabs-tab-btn {
    font-weight: 600;
  }

  .panorama-tabs-content-holder {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  .panorama-tabs-content {
    flex: 1;
    min-height: 0;
  }

  .panorama-tabs-tabpane-active {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }
`;
